export const IS_ADD_ANNOTATION_MODAL_OPEN = "IS_ADD_ANNOTATION_MODAL_OPEN"
export const SET_VIDEO_START_TIME = "SET_VIDEO_START_TIME"
export const SET_PIN_MODE = "SET_PIN_MODE"
